import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText,
}: ConfirmModalProps) {
  const { t } = useTranslation('common');
  const finalConfirmText = confirmText ?? t('confirmModal.confirm');
  const finalCancelText = cancelText ?? t('confirmModal.cancel');

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-[16px]"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-[24px] p-[24px] md:p-[40px] max-w-[580px] w-full">
        <div className="flex flex-col gap-[16px] mb-[40px]">
          <h2 className="font-manrope font-bold text-[24px] md:text-[32px] leading-[32px] md:leading-[40px] text-[#0d0d0d]">
            {title}
          </h2>
          <p className="font-segoe text-[14px] md:text-[16px] leading-[20px] md:leading-[24px] text-[#565858]">
            {description}
          </p>
        </div>

        <div className="flex gap-[24px]">
          <button
            onClick={onClose}
            className="flex-1 bg-transparent border border-[var(--grey-accent,#eeeeee)] border-solid text-[color:var(--black-text,#0d0d0d)] px-[24px] py-[12px] rounded-[16px] font-segoe font-semibold text-[16px] leading-[24px] hover:bg-[#2197f1] hover:text-white hover:border-[#2197f1] transition-colors text-center"
          >
            {finalCancelText}
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 bg-[#2197f1] text-white px-[24px] py-[12px] rounded-[16px] font-segoe font-semibold text-[16px] leading-[24px] hover:opacity-90 transition-opacity text-center"
          >
            {finalConfirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
